import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_private/_auth/set-password')({
  beforeLoad: async () => {
    throw redirect({ to: '/' });
  },
});
